import { useState } from 'react';

export default function useUpsellBanner() {
  const [upsellBannerVisible, showUpsellBanner] = useState(true);
  const hideUpsellBanner = () => showUpsellBanner(false);

  return { upsellBannerVisible, hideUpsellBanner };
}
